var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-dropdown-selection.ts
import { A } from "@adornis/base/env-info";
import { BehaviorController } from "@adornis/chemistry/controllers/behavior-controller";
import { ObservableController } from "@adornis/chemistry/controllers/observable-controller";
import { css } from "@adornis/chemistry/directives/css";
import { inputToken } from "@adornis/chemistry/elements/theming/input-token";
import { xComponents } from "@adornis/chemistry/elements/x-components";
import "@adornis/chemistry/renderable";
import { FormField } from "@adornis/forms/form-field";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { guard } from "lit/directives/guard.js";
import { ref } from "lit/directives/ref.js";
import { repeat } from "lit/directives/repeat.js";
import { fromEvent } from "rxjs";
import { delay, filter, switchMap, takeUntil, tap } from "rxjs/operators";
import "./a-drop-wrapper";
import "./a-drop-wrapper";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/forms/x-input";
var ElementsDropdownSelection = class extends FormField {
  constructor() {
    super(...arguments);
    this._activated = false;
    this.selectables = new BehaviorController(this, []);
    this.searchString = new BehaviorController(this, "");
    this.guardKey = "";
    this.searchResultSelectables = new ObservableController(
      this,
      this.searchString.pipe(
        switchMap(async (str) => (!str ? this.selectables.getValue() : this.search?.(str)) ?? []),
        tap((arr) => {
          if (!Array.isArray(arr))
            throw new Error("search callback didnt give me an array");
        })
      )
    );
    this.placeholder = "";
    this["placeholder-mode"] = "floating";
    this["use-slot"] = false;
    this._preSelectedItem = -1;
    this.renderItem = (x) => html`
    <x-flex
      ${css({
      padding: `${this.spacing.sm} ${this.spacing.md}`,
      cursor: "pointer",
      borderBottom: `1px solid ${this.colors.neutral_100}`
    })}
    >
      <x-text> ${this.renderString(x)} </x-text>
    </x-flex>
  `;
    this.renderString = (x) => typeof x === "string" || typeof x === "number" ? x : JSON.stringify(x);
    this.resolveID = (x) => x?._id || A.getGloballyUniqueID();
    this.search = null;
  }
  get inputToken() {
    return inputToken(this);
  }
  styles() {
    return {
      ":host([error]) #trigger": { borderColor: this.colors.tone.error + " !important" }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("tabindex", "0");
    fromEvent(this, "focus", { passive: true }).pipe(delay(0), takeUntil(this.disconnected)).subscribe(async () => {
      if (this.disabled)
        return;
      if (!this._activated) {
        this._activated = true;
        await this.updateComplete;
      }
      if (getActiveElement() === this)
        this._adropdown?.open();
    });
    fromEvent(this, "blur", { passive: true }).pipe(delay(0), takeUntil(this.disconnected)).subscribe(async () => {
      let element = getActiveElement();
      if (element) {
        if (element === this.dropdownContent || element.classList.contains("tippy-box") && element.getAttribute("role") === "tooltip")
          return;
        while (element = element.parentElement)
          if (element === this.dropdownContent || element.classList.contains("tippy-box") && element.getAttribute("role") === "tooltip")
            return;
      }
      this._adropdown?.close();
    });
    fromEvent(this, "keydown").pipe(
      filter(
        (e) => e.key === "ArrowDown" || e.key === "Down" || e.key === "ArrowUp" || e.key === "Up"
      ),
      tap((e) => e.preventDefault()),
      takeUntil(this.disconnected)
    ).subscribe((e) => {
      const offset = e.key === "ArrowDown" || e.key === "Down" ? 1 : -1;
      const selectables = this.selectables.getValue() || [];
      if (this._preSelectedItem === -1)
        if (offset < 0)
          this._preSelectedItem = selectables.length - 1;
        else
          this._preSelectedItem = 0;
      else if (offset > 0 && this._preSelectedItem === selectables.length - 1)
        this._preSelectedItem = 0;
      else if (offset < 0 && this._preSelectedItem === 0)
        this._preSelectedItem = selectables.length - 1;
      else
        this._preSelectedItem = this._preSelectedItem + offset;
    });
    fromEvent(this, "keydown", { passive: true }).pipe(
      filter((e) => e.key === "Enter"),
      takeUntil(this.disconnected)
    ).subscribe((e) => {
      const selectables = this.selectables.getValue() || [];
      if (this._preSelectedItem !== -1 && selectables[this._preSelectedItem] !== void 0) {
        this.value.next(selectables[this._preSelectedItem]);
        this.dispatchEvent(
          new CustomEvent("value-picked", { detail: { value: selectables[this._preSelectedItem] } })
        );
      }
      this._adropdown?.toggle();
    });
  }
  get hasValue() {
    return this.value.getValue() !== null && this.value.getValue() !== void 0 && this.value.getValue() !== "";
  }
  get showLabel() {
    return this.hasValue || this.error;
  }
  async getUpdateComplete() {
    const result = await super.getUpdateComplete();
    await new Promise((resolve) => requestAnimationFrame(() => resolve()));
    return result;
  }
  render() {
    const trigger = html`
      <div
        slot="trigger"
        @mousedown=${async () => {
      if (this.disabled)
        return;
      if (!this._activated) {
        this._activated = true;
        await this.updateComplete;
      }
      let blur = this._adropdown?.isOpen();
      this._adropdown?.toggle();
      if (blur)
        setTimeout(() => this.blur());
    }}
        ${css({ cursor: !this.disabled ? "pointer" : "initial" })}
      >
        ${this.placeholder || !this["use-slot"] ? html`
              <x-flex
                horizontal
                crossaxis-center
                id="trigger"
                ${css({
      ...this.inputToken,
      border: this.error ? `2px solid ${this.colors.tone.error}` : this.inputToken.border,
      paddingTop: `calc(${this.inputToken.paddingTop} - 1px)`,
      paddingBottom: `calc(${this.inputToken.paddingBottom} - 1px)`,
      position: "relative",
      userSelect: "none"
    })}
                space="sm"
              >
                <x-text flex tone=${this.hasValue ? "" : "subtle"}>
                  ${this.hasValue ? this.renderString(this.value.getValue()) : this.placeholder}
                </x-text>
                ${this._icon()}
              </x-flex>
            ` : html` <slot></slot> `}
      </div>
    `;
    const label = this._label();
    if (!this._activated)
      return xComponents(html` <x-flex> ${label} ${trigger} </x-flex> `);
    return xComponents(html`
      <x-flex>
        ${label}
        <a-dropdown id="dropdown" ${ref((dropdown) => this._adropdown = dropdown)}>
          ${trigger} ${this._dropdownContent()}
        </a-dropdown>
      </x-flex>
    `);
  }
  _label() {
    return (this.placeholder || this.error) && this["placeholder-mode"] === "floating" ? html`
          <x-text
            ${css({
      userSelect: "none",
      marginLeft: this.spacing.md,
      marginBottom: !!this.showLabel ? this.spacing.xs : "0",
      opacity: !!this.showLabel ? "1" : "0",
      transform: !!this.showLabel ? "translateY(0)" : "translateY(20px)",
      transition: "opacity .12s ease, transform .12s ease, max-height .12s ease, margin .12s ease",
      maxHeight: !!this.showLabel ? "30px" : "0px",
      color: this.error ? this.colors.tone.error : "",
      pointerEvents: "none"
    })}
            tone="subtle"
          >
            ${this.error || this.placeholder}
          </x-text>
        ` : nothing;
  }
  _icon() {
    return html` <x-icon> keyboard_arrow_down </x-icon> `;
  }
  _dropdownContent() {
    return html`
      ${guard(
      [
        (this.search ? this.searchResultSelectables.value : this.selectables.value)?.map((s) => this.guardKey ? s[this.guardKey] : s).join(),
        this._preSelectedItem
      ],
      () => xComponents(html`
            <x-flex
              slot="dropdown-content"
              ${css({
        background: this.colors.white,
        borderRadius: this.sizes.borderRadius,
        boxShadow: this.shadows[2],
        maxHeight: "40vh",
        overflowY: "auto"
      })}
              ${ref((dropdownContent) => this.dropdownContent = dropdownContent)}
            >
              ${this._search()} ${this._items()}
            </x-flex>
          `)
    )}
    `;
  }
  _search() {
    return this.search ? html`
          <x-input
            ${css({ paddingTop: this.spacing.sm })}
            placeholder="Suchen..."
            placeholder-mode="hide"
            @value-changed=${(e) => this.searchString.next(e.detail.value)}
            disable-blur-submit
          ></x-input>
        ` : nothing;
  }
  _items() {
    return xComponents(html`
      <x-flex ${css({ paddingTop: this.spacing.sm, paddingBottom: this.search ? this.spacing.sm : "" })}>
        ${repeat(
      (this.searchString.getValue() ? this.searchResultSelectables.value : this.selectables.value) || [],
      (s) => this.resolveID(s),
      (selectable, index) => html`
              <div
                ${css({
        background: this._preSelectedItem === index ? this.colors.neutral_100 : "transparent"
      })}
                @click=${() => {
        this.focus();
        setTimeout(() => {
          this._adropdown?.close();
          this.value.next(selectable);
          this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: selectable } }));
        }, 25);
      }}
              >
                ${this.renderItem(selectable)}
              </div>
            `
    )}
      </x-flex>
    `);
  }
};
__decorateClass([
  state()
], ElementsDropdownSelection.prototype, "_activated", 2);
__decorateClass([
  state()
], ElementsDropdownSelection.prototype, "selectables", 2);
__decorateClass([
  state()
], ElementsDropdownSelection.prototype, "searchString", 2);
__decorateClass([
  state()
], ElementsDropdownSelection.prototype, "guardKey", 2);
__decorateClass([
  state()
], ElementsDropdownSelection.prototype, "searchResultSelectables", 2);
__decorateClass([
  property()
], ElementsDropdownSelection.prototype, "placeholder", 2);
__decorateClass([
  property()
], ElementsDropdownSelection.prototype, "placeholder-mode", 2);
__decorateClass([
  property({ type: Boolean })
], ElementsDropdownSelection.prototype, "use-slot", 2);
__decorateClass([
  state()
], ElementsDropdownSelection.prototype, "_preSelectedItem", 2);
ElementsDropdownSelection = __decorateClass([
  customElement("x-dropdown-selection")
], ElementsDropdownSelection);
var getActiveElement = (root = document) => {
  const activeEl = root.activeElement;
  if (!activeEl)
    return null;
  if (activeEl.shadowRoot)
    return getActiveElement(activeEl.shadowRoot) || activeEl;
  else
    return activeEl;
};
export {
  ElementsDropdownSelection
};
